import {RouteRecordRaw} from "vue-router";
import Lista from "../pages/temas/Temas.vue";
import FormularioTemas from "../pages/temas/FormularioTemas.vue";

export const Temas: RouteRecordRaw[] = [
    {name: 'temas', path: '/temas', meta: {title: 'Temas'}, component: Lista},
    {name: 'temas.nuevo', path: '/temas/nuevo', meta: {title: 'Nuevo tema'}, component: FormularioTemas},
    {name: 'temas.editar', path: '/temas/:id', meta: {title: 'Editar tema'}, component: FormularioTemas},
];